import React from "react";
import PropTypes from "prop-types";
import { Alert, Button } from "antd";
import { withUser } from "@unifiedpatents/sso";

const CallToLogin = ({ text = "Please login to access all functions. ", style, user: { action } }) => {
  return (
    <Alert
      type="info"
      showIcon={true}
      message={
        <span>
          {text}
          <Button size="small" type="primary" onClick={action.showLoginPopup} style={{ marginLeft: 16 }}>
            Log In
          </Button>
        </span>
      }
      style={style}
    />
  );
};
CallToLogin.propTypes = {
  text: PropTypes.string
};

export default withUser(CallToLogin);
